module.exports = __webpack_public_path__ + "img/bg_ghost_07@3x.40c83f38.png";